<template lang="pug">
v-container.pt-8(style="max-width:960px")
  v-layout.pa-6(v-if="isFetching")
    v-row.fill-height.ma-0(align='center' justify='center')
      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
  template(v-else)
    v-row
      v-col
        div.heading-5.basic700--text {{ campaign.title }}
        div.text-sm.font-medium.info500--text.clickable {{ getPageLink() }}
      v-col.shrink
        div.d-flex
          v-btn.heading-7.pr-4.pl-3(color="basic700" small height="32" outlined style="border-radius: 8px;" @click="goToLink")
            eva-icon.mr-1.mb-n1(name="diagonal-arrow-right-up-outline" height="20" width="20" fill="var(--v-basic700)")
            | {{ $t('go_to_link') }}
          v-btn.heading-7.pr-4.pl-3.ml-2(color="basic700" small dark height="32" style="border-radius: 8px;" @click="copyUrl" v-clipboard:copy="getPageLink()")
            eva-icon.mr-1.mb-n1(name="copy-outline" height="20" width="20" fill="white" )
            | {{ $t('copy_link') }}

    div.main-container.my-5
      v-row(no-gutters)
        v-col(cols="12" sm="8")
          v-tabs(v-model="campaignTab" color="basic700" :height="40" grow)
            v-tab.text-lg.font-medium.text-capitalize.px-0 {{ $t('details') }}
            v-tab.text-lg.font-medium.text-capitalize.px-0 {{ $t('payment') }}
            v-tab.text-lg.font-medium.text-capitalize.px-0 {{ $t('sharing') }}
            v-tab.text-lg.font-medium.text-capitalize.px-0 {{ $t('donor') }}
            v-tab.text-lg.font-medium.text-capitalize.px-0 {{ $t('fundraiser') }}
            v-tab.text-lg.font-medium.text-capitalize.px-0 {{ $t('transactions') }}
          
      div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

    v-tabs-items(v-model="campaignTab" touchless)
      v-tab-item
        manage-campaign-details
      v-tab-item
        manage-campaign-settings
      v-tab-item
        manage-campaign-sharing
      v-tab-item
        manage-campaign-donors
      v-tab-item
        manage-campaign-fundraiser
      v-tab-item
        manage-campaign-transactions

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ManageCampaignDetails from '@/components/donation/campaign/ManageCampaignDetails.vue'
import ManageCampaignSharing from '@/components/donation/campaign/ManageCampaignSharing.vue'
import ManageCampaignSettings from '@/components/donation/campaign/ManageCampaignSettings.vue'
import ManageCampaignDonors from '@/components/donation/campaign/ManageCampaignDonors.vue'
import ManageCampaignFundraiser from '@/components/donation/campaign/ManageCampaignFundraiser.vue'
import ManageCampaignTransactions from '@/components/donation/campaign/ManageCampaignTransactions.vue'

export default {
  name: 'ManageCampaign',
  components: { ManageCampaignDetails, ManageCampaignSharing, ManageCampaignSettings, ManageCampaignDonors, ManageCampaignFundraiser, ManageCampaignTransactions },
  props: ['pid'],
  data () {
    return {
      isFetching: false,
      campaignTab: 0
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
  },
  created () {
    this.fetchCampaign()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCampaign () {
      this.isFetching = true
      this.$axios.get(`/donations/${this.company.slug}/campaigns/${this.pid}`)
        .then(resp => {
          this.$store.commit('donation/setCampaign', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    getPageLink () {
      return `https://${this.company.slug}.yezza.co/donation/${this.pid}`
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    goToLink () {
      window.open(this.getPageLink(), '_blank')
    }
  },
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>